import { AutogenLayoutDataFusionErrorPanel } from "./autogen/AutogenLayoutDataFusionErrorPanel";

export class DataFusionErrorPanel extends AutogenLayoutDataFusionErrorPanel {

}
